import Vue from "vue";
import {
  Loading,
  Empty,
  Tag,
  Row,
  Table,
  TableColumn,
  Col,
  Radio,
  RadioGroup,
  Dialog,
  Button,
  Container,
  Header,
  Main,
  Pagination,
  Select,
  Option,
  Footer,
  Form,
  FormItem,
  Input,
  Image,
  Popover,
  Carousel,
  CarouselItem,
  Cascader,
  DatePicker,
  Popconfirm,
  Link,
  Divider,
  CheckboxGroup,
  Checkbox,
} from "element-ui";
Vue.use(Empty);
Vue.use(Row);
Vue.use(Loading);
Vue.use(Tag);
Vue.use(TableColumn);
Vue.use(Table);
Vue.use(Col);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Pagination);
Vue.use(Select);
Vue.use(Option);
Vue.use(Footer);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Image);
Vue.use(Popover);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Cascader);
Vue.use(DatePicker);
Vue.use(Popconfirm);
Vue.use(Link);
Vue.use(Divider);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
